import { Box } from "@mui/system";
import { Typography } from "@material-ui/core";
// components
import PageHeader from "../../components/PageHeader";

export default function InformativaPrivacy() {
  return (
    <Box
      sx={{
        padding: {
          xs: "20px",
          sm: "35px",
          md: "54px",
        },
        paddingBottom: {
          xs: "100px !important",
          md: "150px !important",
        },
      }}
    >
      <PageHeader title="Informativa Privacy" />

      <Box style={styles.boxParagraph}>
        <Typography style={styles.intro}>
          Informativa ai sensi dell'art. 13 del Regolamento Europeo 679/2016 GDPR
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          1) Titolare del trattamento e responsabile della protezione dei dati personali
        </Typography>
        <Typography style={styles.text}>
          Titolare del trattamento è The Bloc Italy S.r.l. SB, in persona del proprio legale rappresentante pro
          tempore, con sede legale in Milano, Via Tommaso Agudio, 2 – 20154 C.F, P.IVA e Reg. Imp. Milano
          07194560962 – REA MI-1942230.
        </Typography>
        <Typography style={styles.text}>
          Il Titolare può essere contattato mediante e-mail all'indirizzo italy.info@thebloc.com
        </Typography>
        <Typography style={styles.text}>
          Il titolare ha nominato un responsabile della protezione dei dati personali (DPO) contattabile
          all'indirizzo mail dpo@thebloc.com
        </Typography>
        <Typography style={styles.text}>
          Il trattamento dati, come di seguito descritto, avviene in Milano, Via Tommaso Agudio, 2 tramite
          sistema cloud completamente automatizzato.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          2) Tipologia di dati e ruoli nel trattamento
        </Typography>

        <Typography style={{ ...styles.text, ...styles.bold }}>
          TRATTAMENTI PER I QUALI THE BLOC AGISCE COME TITOLARE:
        </Typography>
        <Typography style={styles.text}>
          The Bloc tratta in qualità di titolare del trattamento i seguenti dati personali comuni:
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          Nome, cognome, numero di telefono ed indirizzo e-mail
        </Typography>
        <Typography style={styles.text}>
          Tali dati saranno forniti da Lei mediante inserimento sul portale www.caretogether.com.
        </Typography>

        <Typography style={{ ...styles.text, ...styles.bold }}>
          TRATTAMENTI PER I QUALI THE BLOC AGISCE COME RESPONSABILE:
        </Typography>
        <Typography style={styles.text}>
          The Bloc tratta in qualità di responsabile del trattamento, per conto di UGO pnp S.r.l. (con sede in
          Milano, via Castaldi n. 29, 20124, P.IVA e C.F. 08979490961), dati particolari relativi alla salute ex
          art. 9 GDPR.
        </Typography>
        <Typography style={styles.text}>
          Tali dati saranno da Lei comunicati al personale autorizzato di The Bloc che provvederà ad inserirli
          nel sistema informatico di UGO pnp S.r.l.
        </Typography>
        <Typography style={styles.text}>
          The Bloc non conserva tali dati sanitari.
        </Typography>
        <Typography style={styles.text}>
          Per informazioni complete sul trattamento dei dati sanitari, sulle finalità, sulle basi giuridiche, sui
          tempi di conservazione e sui Suoi diritti in relazione a tali dati, La invitiamo a consultare
          l'informativa privacy di UGO pnp S.r.l., disponibile sul sito www.hellougo.com, presso il personale
          autorizzato o richiedendola all'indirizzo privacy@hellougo.com.
        </Typography>

        <Typography style={{ ...styles.text, ...styles.bold }}>
          Dati di navigazione:
        </Typography>
        <Typography style={styles.text}>
          Il sito internet, nel corso del suo funzionamento, potrà acquisire alcuni dati la cui trasmissione è
          automatica nel corso della navigazione quali, ad esempio, indirizzo IP, identificativi on line, orario
          del contatto, ma saranno utilizzati solo per fornire statistiche anonime sull'uso del sito stesso e
          controllarne eventuali anomalie, così come evitare frodi; a quest'ultimo scopo, i dati potranno
          essere utilizzati ai soli fini di eventuali comunicazioni alle competenti Autorità ai fini
          dell'accertamento di responsabilità.
        </Typography>
        <Typography style={styles.text}>
          I servizi non sono accessibili ai minori di anni 14 senza il preventivo consenso di chi esercita la
          responsabilità genitoriale, ai sensi dell'art. 8 del GDPR e dell'art. 2-quinquies del Codice Privacy
          italiano.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          3) Finalità e modalità del trattamento dei dati (trattamenti come titolare)
        </Typography>
        <Typography style={styles.text}>
          I dati comuni (email e telefono) trattati da The Bloc in qualità di titolare sono utilizzati per le
          seguenti finalità:
        </Typography>
        <Typography style={styles.text}>
          a) Erogazione del servizio di intermediazione: L'indirizzo e-mail e il numero di telefono sono
          utilizzati per consentire l'accesso alla piattaforma sanitaria. The Bloc agisce come intermediario
          per consentire l'accesso ai servizi sanitari forniti da UGO pnp S.r.l.
        </Typography>
        <Typography style={styles.text}>
          b) Rilevazione del livello di soddisfazione del cliente (customer satisfaction): L'indirizzo e-mail e
          il numero di telefono potranno essere utilizzati per contattarla successivamente all'erogazione del
          servizio, al fine di rilevare il Suo livello di soddisfazione mediante invio di questionari o contatto
          telefonico. Tale attività potrà essere svolta occasionalmente (indicativamente non più di una volta
          in due anni) e riguarderà esclusivamente valutazioni generiche sul servizio ricevuto, senza alcun
          trattamento di dati particolari.
        </Typography>
        <Typography style={styles.text}>
          I dati saranno trattati con strumenti elettronici. I dati potranno essere trattati tramite dispositivi
          informatici in cloud; il cloud provider di The Bloc è Aruba, sito all'interno dello Spazio Economico
          Europeo.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          4) Base giuridica del trattamento (trattamenti come titolare)
        </Typography>
        <Typography style={styles.text}>
          Le basi giuridiche del trattamento dei dati comuni da parte di The Bloc sono:
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          Per la finalità a) (erogazione del servizio di intermediazione): esecuzione del contratto o di misure
          precontrattuali adottate su richiesta dell'interessato, ai sensi dell'art. 6 comma 1 lett. b del Reg.
          UE 679/16.
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          Per la finalità b) (customer satisfaction): Consenso ai sensi dell'art. 6 comma 1 lett. a del Reg.
          UE 679/16.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          5) Destinatari dei dati
        </Typography>
        <Typography style={styles.text}>
          I dati personali comuni trattati da The Bloc in qualità di titolare potranno essere trattati da
          fornitori di servizi IT debitamente nominati responsabili ai sensi dell'articolo 28 del GDPR. I dati
          non saranno trattati al di fuori dello Spazio Economico Europeo (SEE).
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          6) Conservazione dei dati (trattamenti come titolare)
        </Typography>
        <Typography style={styles.text}>
          I dati personali comuni (email e telefono) saranno conservati per due anni dalla cessazione del
          servizio. Tale periodo è necessario per consentire a The Bloc di effettuare le rilevazioni di customer
          satisfaction e mantenere uno storico dei contatti utile al miglioramento continuo del servizio
          offerto.
        </Typography>
        <Typography style={styles.text}>
          Decorso tale termine, seguirà cancellazione dei dati, salvo che la conservazione non sia necessaria
          per l'adempimento di obblighi di legge o per l'accertamento, l'esercizio o la difesa di un diritto in
          sede giudiziaria.
        </Typography>
        <Typography style={styles.text}>
          The Bloc non conserva i dati sanitari, limitandosi alla loro raccolta e registrazione all'interno dei
          sistemi informatici di Ugo.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          7) Conseguenze della mancata comunicazione dei dati
        </Typography>
        <Typography style={styles.text}>
          La mancata comunicazione dei dati comuni (email e telefono) impedisce l'accesso alla piattaforma
          e quindi l'erogazione del servizio di intermediazione.
        </Typography>
        <Typography style={styles.text}>
          Per le conseguenze relative alla mancata prestazione del consenso per i dati sanitari, consulti
          l'informativa di UGO pnp S.r.l.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          8) Diritti dell'interessato
        </Typography>
        <Typography style={styles.text}>
          Lei ha il diritto di:
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          chiedere a The Bloc l'accesso ai dati personali comuni ed alle informazioni relative agli stessi; la
          rettifica dei dati inesatti o l'integrazione di quelli incompleti; la cancellazione dei dati personali
          che La riguardano; la limitazione del trattamento;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          richiedere ed ottenere i dati personali in un formato strutturato e leggibile da dispositivo
          automatico (diritto alla portabilità);
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          opporsi in qualsiasi momento al trattamento dei dati personali comuni per la finalità di customer
          satisfaction, basato sul legittimo interesse di The Bloc ai sensi dell'art. 21 del GDPR. In caso di
          opposizione, The Bloc cesserà immediatamente il trattamento dei dati per tale specifica finalità;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          proporre reclamo all'Autorità Garante per la protezione dei dati personali (www.garanteprivacy.it).
        </Typography>
        <Typography style={styles.text}>
          Per i diritti relativi ai dati sanitari (trattati da UGO pnp S.r.l. come titolare), consulti l'informativa
          di UGO pnp S.r.l.
        </Typography>
        <Typography style={styles.text}>
          Per esercitare i diritti relativi ai dati comuni trattati da The Bloc, può inviare richiesta scritta a:
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          E-mail: italy.info@thebloc.com
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          Posta: Via Tommaso Agudio, 2 – 20154 Milano
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          9) Sicurezza dei dati
        </Typography>
        <Typography style={styles.text}>
          The Bloc adotta misure di sicurezza tecniche e organizzative (password, firewall, antivirus, backup)
          per proteggere i dati da accessi non autorizzati, in conformità all'art. 32 GDPR.
        </Typography>
        <Typography style={styles.text}>
          Il personale autorizzato di The Bloc che tratta dati sanitari in qualità di responsabile per conto di
          UGO pnp S.r.l. è vincolato da specifici obblighi di riservatezza ai sensi dell'art. 29 GDPR.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          10) Profilazione e marketing
        </Typography>
        <Typography style={styles.text}>
          The Bloc non effettua profilazione né processi decisionali automatizzati. I dati non verranno
          utilizzati per l'invio di comunicazioni commerciali o attività di marketing.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={styles.text}>
          Il titolare può essere contattato via e-mail all'indirizzo italy.info@thebloc.com
        </Typography>
        <Typography style={styles.text}>
          Dichiaro di aver letto e compreso i termini della sopra estesa informativa privacy.
        </Typography>
      </Box>
    </Box>
  );
}

const styles = {
  boxParagraph: {
    marginBottom: "20px",
  },
  intro: {
    fontWeight: "bold",
    fontSize: "16px",
  },
  text: {
    marginBottom: "8px",
    display: "block",
  },
  italic: {
    fontStyle: "italic",
  },
  bold: {
    fontWeight: "bold",
  },
  indent: {
    paddingLeft: "20px",
    display: "block",
    marginBottom: "6px",
  },
};
